module.exports = __webpack_public_path__ + "static/img/chanta (2).472800b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (2).jpg
// module id = o78i
// module chunks = 0